module.exports = __webpack_public_path__ + "img/logo_2023-college-football-playoff.4de5cc91.png";